import {Component, Inject, LOCALE_ID, OnInit, Renderer2} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ProjectsService} from "../services/projects.service";
import {RegistrationsService} from "../services/registrations.service";
import {ToastrService} from "ngx-toastr";
import {CoreService} from "../services/core.service";
import {TranslateService} from "@ngx-translate/core";
import {ThemesService} from "../services/themes.service";
import {environment} from "../../../environments/environment";
import {Project} from "../models/project.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.sass']
})
export class DemoComponent implements OnInit {

  public projectShortname: string | null = null;
  public UxMessageSuccess = null;
  public UxMessageError = null;
  public loading = true;
  public webServiceUrl = environment.spaUrl;

  private ngUnsubscribe = new Subject<void>();

  public submitButtonActive = false;
  public firstSectionValueValid = false;
  public secondSectionValuesValid = false;
  public showFirstSection = true;
  public showSecondSection = false;

  public projectShortName = '';

  public salutationValues: any[] = [];

  public project: Project = new Project();

  public demoForm: FormGroup = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    tooltipField: new FormControl('', [Validators.required]),
    testValid: new FormControl('', [Validators.required]),
    testInvalid: new FormControl('', [Validators.required]),
    salutation: new FormControl('', [Validators.required]),
    tos: new FormControl(false, [Validators.requiredTrue])
  });

  // Add getter methods for form controls
  get firstnameControl(): FormControl {
    return this.demoForm.get('firstname') as FormControl;
  }

  get tooltipFieldControl(): FormControl {
    return this.demoForm.get('tooltipField') as FormControl;
  }

  get testValidControl(): FormControl {
    return this.demoForm.get('testValid') as FormControl;
  }

  get testInvalidControl(): FormControl {
    return this.demoForm.get('testInvalid') as FormControl;
  }

  get salutationControl(): FormControl {
    return this.demoForm.get('salutation') as FormControl;
  }

  get tosControl(): FormControl {
    return this.demoForm.get('tos') as FormControl;
  }

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectsService,
    private registrationService: RegistrationsService,
    private toastrService: ToastrService,
    private router: Router,
    public coreService: CoreService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private themeService: ThemesService
  ) {}

  ngOnInit(): void {
    //load current project
    this.projectShortname = this.activatedRoute.snapshot.paramMap.get('projectShortname');

      this.projectService.globalLoadingSignal.set(true);
      this.projectService.getProject('oca').pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe({
          next: (project) => {
            this.themeService.checkThemeSettings(this.projectShortname);
            this.projectService.setLoading(true);

            this.project = project;

            this.salutationValues = [
              {index: 'Herr', name: 'Herr'},
              {index: 'Frau', name: 'Frau'}
            ];

            // Disable loading spinner after project is loaded
            this.coreService.disableGlobalLoading();
          },
          complete: () => {
            // Ensure loading is disabled even if there's an error
            this.coreService.disableGlobalLoading();
          },
          error: err => {
            this.toastrService.error(err);
            // Ensure loading is disabled on error
            this.coreService.disableGlobalLoading();
          }
        }
      );
  }
}
